<template>
  <v-row no-gutters>
    <v-col cols="12">
      <app-ag-grid
        title="Credit Notes"
        :columnDefs="columnDefs"
        :rowData="creditNotes"
        :loading="loading"
        @refresh="fetchCreditNotes"
        @add="onAdd"
        :mobileCard="mobileCard"
        @row-dbl-click="
          (data) => $router.push({ path: `credit-notes/${data._id}/edit` })
        "
      />
    </v-col>
  </v-row>
</template>

<script>
import AppAgGrid from "@/components/common/ag-grid.vue";

export default {
  name: "CreditNotesPage",
  components: {
    AppAgGrid,
  },

  data() {
    return {
      loading: false,
      columnDefs: [
        {
          headerName: "View",
          field: "_id",
          minWidth: 80,
          cellRenderer: (params) => {
            return `
              <i
                class="mdi mdi-eye view-credit-note"
                data-id="${params.data._id}"
                title="View Credit Note"
                style="
                  cursor: pointer;
                  font-size: 18px;
                  color: #0a5a90;
                "
              ></i>
            `;
          },

          onCellClicked: (params) => {
            if (params.event.target.classList.contains("view-credit-note")) {
              this.$router.push({ path: `credit-notes/${params.data._id}/view` });
            }
          },
        },
        { headerName: "Credit Note #", field: "creditNoteNumber", minWidth: 130 },
        { headerName: "Against Invoice #", field: "invoiceNumber", minWidth: 150 },
        { headerName: "Customer", field: "customer.name", minWidth: 160 },
        {
          headerName: "Credit Note Date",
          field: "creditNoteDate",
          minWidth: 140,
          valueFormatter: (p) => this.formatDate(p.value),
        },
        {
          headerName: "Amount",
          field: "totalAmount",
          minWidth: 140,
          valueFormatter: (p) => this.formatCurrency(p.value),
        },
        { headerName: "Reason", field: "reason", minWidth: 160 },
        { headerName: "Status", field: "status", minWidth: 120 },
      ],
    };
  },

  computed: {
    creditNotes() {
      return this.$store.state.creditNotes.list || [];
    },

    mobileCard() {
      const statusColors = {
        ISSUED: { background: "#e6f7ec", color: "#15803d" },
        CANCELLED: { background: "#fdecea", color: "#c62828" },
      };

      return {
        title: (row) => `#${row.creditNoteNumber}`,
        subtitle: (row) => row.customer?.name || "-",
        badge: (row) => ({
          text: row.status || "-",
          style: statusColors[row.status] || { background: "#f1f5f9", color: "#475569" },
        }),
        fields: (row) => [
          { label: "Amount", value: this.formatCurrency(row.totalAmount) },
          { label: "Against Invoice", value: `#${row.invoiceNumber}` },
        ],
        actions: (row) => [
          {
            label: "View",
            icon: "mdi-eye-outline",
            color: "#0a5a90",
            onClick: () => this.$router.push({ path: `credit-notes/${row._id}/view` }),
          },
          {
            label: "Edit",
            icon: "mdi-pencil-outline",
            color: "#475569",
            onClick: () => this.$router.push({ path: `credit-notes/${row._id}/edit` }),
          },
        ],
      };
    },
  },

  created() {
    this.fetchCreditNotes();
  },

  methods: {
    async fetchCreditNotes() {
      this.loading = true;
      try {
        await this.$store.dispatch("creditNotes/getCreditNotes");
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    onAdd() {
      this.$router.push({ path: "credit-notes/create" });
    },

    formatCurrency(value) {
      if (value == null) return "-";
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
      }).format(value);
    },

    formatDate(value) {
      if (!value) return "-";
      const date = new Date(value);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
};
</script>
